import { apiGet } from "./apiClient";

export const getNegoRequests = async (page = 0, size = 10, sortBy = 'requestDateTime', sortDir = 'desc') => {
  try {
    const response = await apiGet(`/admin/negorequest?page=${page}&size=${size}&sort=${sortBy},${sortDir}`);
    if (response.ok) return { success: true, data: await response.json(), error: null };
    return { success: false, data: null, error: "네고 요청 목록 조회 실패" };
  } catch {
    return { success: false, data: null, error: "네트워크 오류" };
  }
};

export const getNegoRequestLogs = async (page = 0, size = 10, sortBy = 'requestDateTime', sortDir = 'desc') => {
  try {
    const response = await apiGet(`/admin/negorequest/log?page=${page}&size=${size}&sort=${sortBy},${sortDir}`);
    if (response.ok) return { success: true, data: await response.json(), error: null };
    return { success: false, data: null, error: "네고 요청 내역 조회 실패" };
  } catch {
    return { success: false, data: null, error: "네트워크 오류" };
  }
};

export const searchNegoRequests = async (params, page = 0, size = 10) => {
  try {
    const query = new URLSearchParams({ page, size, sort: 'requestDateTime,desc' });
    if (params.startDate) query.append('startDate', params.startDate);
    if (params.endDate) query.append('endDate', params.endDate);
    if (params.requestStatus !== '' && params.requestStatus !== null && params.requestStatus !== undefined) {
      query.append('requestStatus', params.requestStatus);
    }
    if (params.searchType) query.append('searchType', params.searchType);
    if (params.searchTerm) query.append('searchTerm', params.searchTerm);
    const response = await apiGet(`/admin/negorequest/search?${query.toString()}`);
    if (response.ok) return { success: true, data: await response.json(), error: null };
    return { success: false, data: null, error: "네고 요청 검색 실패" };
  } catch {
    return { success: false, data: null, error: "네트워크 오류" };
  }
};

export const searchNegoRequestLogs = async (params, page = 0, size = 10) => {
  try {
    const query = new URLSearchParams({ page, size, sort: 'requestDateTime,desc' });
    if (params.startDate) query.append('startDate', params.startDate);
    if (params.endDate) query.append('endDate', params.endDate);
    if (params.requestLogStatus) query.append('requestLogStatus', params.requestLogStatus);
    if (params.searchType) query.append('searchType', params.searchType);
    if (params.searchTerm) query.append('searchTerm', params.searchTerm);
    const response = await apiGet(`/admin/negorequest/log/search?${query.toString()}`);
    if (response.ok) return { success: true, data: await response.json(), error: null };
    return { success: false, data: null, error: "네고 요청 내역 검색 실패" };
  } catch {
    return { success: false, data: null, error: "네트워크 오류" };
  }
};
